/* eslint-disable */
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '../../Components/ui/card'
import { Button } from '../../Components/ui/button'
import { Label } from '../../Components/ui/label'
import { Input } from '../../Components/ui/input'
import { post } from '../../http/restservice'
import env from '../../env/env'
import { ChevronDown, ChevronLeft } from 'lucide-react'
import { useModal } from '../../hooks/use-modal-store'
import { MFTimeBasedBaskets } from '../../store/MFBasketsStore'
import { useRecoilValueLoadable } from 'recoil'
import { toCurrency } from '../../utils/CurrencyUtil'

const InvestMoreSIP = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [amount, setAmount] = useState(Number(location?.state?.payload?.orderInvestmentAmount) || 0)
  const [amountInput, setAmountInput] = useState('0')

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  const { onOpen } = useModal()
  const baskets = useRecoilValueLoadable(MFTimeBasedBaskets)

  useEffect(() => {
    setAmountInput(toCurrency(Number(amount || 0)))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleAmountInputChange = (e) => {
    const raw = (e?.target?.value || '').toString().replace(/[^0-9]/g, '')
    const numeric = raw ? Number(raw) : 0
    setAmount(numeric)
    setAmountInput(toCurrency(numeric))
  }

  const educationConstituentsSIPWeightage = {
    // 'edutrg-gr': 0, // 10
    // 'edatgp-gr': 20,
    // 'pp001rg-gr': 25,
    // 'cmfcgp-gr': 30,
    // 'relsegp-gr': 25,
    "hdfcmcog-gr": 10,
    "relsegp-gr": 25,
    "cmfcgp-gr": 30,
    "edatgp-gr": 10,
    "pp001rg-gr": 25,
  }

  const weddingConstituentsWeightageSIP = {
    'edutrg-gr': 0, // 10 Edelweiss US Technology Equity Fund of Fund
    'edmarg-gr': 20, // Edelweiss Multi Asset Allocation Fund-Reg(G)
    'rmfgdgp-gr': 10, // Nippon India Gold Savings Fund(G)
    'pp001rg-gr': 20, // Parag Parikh Flexi Cap Fund-Reg(G)
    earg: 20, // Nippon India Large Cap Fund
    dfg: 20, // ICICI Pru Value Discovery Fund(G)
  }

  const retirementConstituentsWeightageSIP = {
    // 'edutrg-gr': 0, // 20
    // dynmic: 15,
    // 'pp001rg-gr': 15,
    // 'edatgp-gr': 10,
    // 'cmfcgp-gr': 30,
    // 'qumogp-gr': 30,

    "hdfcmcog-gr": 10,
    "hdacgpg-gr": 10,
    "cmfcgp-gr": 25,
    "pp001rg-gr": 15,
    "qumogp-gr": 25,
    "dynmic": 15,
  }

  const oneToThreeYrConstituentsWeightage = {
    'km35-gr': 50, // Kotak Equity Savings
    'pp001rg-gr': 50, // Parag Parikh Flexi Cap Fund
  }

  const oneYrConstituentsWeightage = {
    'edmarg-gr': 50,
    'relmtf-gr': 50,
  }

  const emergencyConstituentsSIPWeightage = { 'edatgp-gr': 100 }

  const commoditiesConstituentsSIPWeightage = {
    'edgfrg-gr': 100,
  }

  const anytimeConstituentsWeightage = {
    'rmfgdgp-gr': 30, // Nippon Gold Fund
    'km35-gr': 70, // Kotak Equity Savings
  }

  // 12

  const threeToSixWithoutUsTechSIP = {
    // 'edatgp-gr': 20, // Edelweiss Multi Asset Allocation Fund-Reg(G)
    // 'pp001rg-gr': 25, // Parag Parikh Flexi Cap Fund-Reg(G)
    // 'cmfcgp-gr': 30,
    // 'relsegp-gr': 25, // Nippon India Large Cap Fund
    "hdfcmcog-gr": 10,
    "relsegp-gr": 25,
    "cmfcgp-gr": 30,
    "edatgp-gr": 10,
    "pp001rg-gr": 25,
  }

  const sixPlusWithoutUsTechSIP = {
    'edatgp-gr': 10, // Edelweiss Multi Asset Allocation Fund-Reg(G)
    'cmfcgp-gr': 30,
    'qumogp-gr': 30, // Quant Momentum Fund
    dynmic: 15, // ICICI Pru multi asset
    'pp001rg-gr': 15, // Parag Parikh Flexi Cap Fund-Reg(G)
  }

  const arbitrageSIP = {
    'edatgp-gr': 100,
  }

  const liquidSIP = {
    'rellftpi-gr': 100,
  }

  const cm = {
    'cmfcgp-gr': 100,
  }
  //16
  const oneTaxEfficient = {
    'edatgp-gr': 50,
    'rmfaf-gr': 50,
  }

  const usTech = {
    'icici1950-gr': 100,
  }

  const chinaEquity = {
    'edgcgp-gr': 100,
  }

  const sifQuant = {
    'quslsgp-gr': 100,
  }

  const sipAggressive4K = {
    'cmfcgp-gr': 25,
    'pp001rg-gr': 25,
    'qumogp-gr': 25,
    'dynmic': 25,
  }

  const sipAggressive2K = {
    'cmfcgp-gr': 50,
    'qumogp-gr': 50,
  }

  const globalFund10Yrs = {
    'edgcgp-gr': 50,
    'edutrg-gr': 50,
  }

  const altivaSIF = {
    'eishlrg-gr': 100,
  }

  const basketOptions = {
    1: '6+ Retirement',
    2: '3-6 Education',
    3: '3-6 Wedding',
    4: '1-3',
    5: '1',
    6: 'Emergency',
    8: 'Commodities',
    10: 'Anytime',
    11: '6+_Retirement_Without_US_Tech',
    12: '3-6_Education_Without_US_Tech',
    13: 'Arbitrage',
    14: 'Liquid',
    15: 'CM',
    16: '1_Tax_Efficient',
    17: 'US_Tech',
    18: 'China_Equity',
    19: 'SIF_6+_Retirement',
    20: 'SIP_Aggressive_4K',
    21: 'SIP_Aggressive_2K',
    22: 'Global Fund - 10 years',
    23: 'Altiva_SIF'
  }

  const universalBasketId =
    +location?.state?.basket[0]?.universalBasketId || +location?.state?.basket?.universalBasketId
  const basketName = basketOptions[universalBasketId]?.toLowerCase()

  const filteredConstituents =
    baskets?.state === 'hasValue'
      ? baskets?.contents?.data
        ?.filter((fund) => fund?.universalBasketId === universalBasketId)
        .map((fund) => ({
          ...fund,

          weightage:
            basketName == '6+ retirement'
              ? retirementConstituentsWeightageSIP[`${fund.bseSchemeCode.toLowerCase()}`]
              : basketName.includes('sif_6+_retirement')
                ? sifQuant[`${fund.bseSchemeCode.toLowerCase()}`]
                : basketName.includes('1_tax_efficient')
                  ? oneTaxEfficient[`${fund.bseSchemeCode.toLowerCase()}`]
                  : basketName.includes('global fund - 10 years')
                    ? globalFund10Yrs[`${fund.bseSchemeCode.toLowerCase()}`]
                    : basketName.includes('altiva_sif')
                      ? altivaSIF[`${fund.bseSchemeCode.toLowerCase()}`]
                      : basketName.includes('sip_aggressive_4k')
                        ? sipAggressive4K[`${fund.bseSchemeCode.toLowerCase()}`]
                        : basketName.includes('sip_aggressive_2k')
                          ? sipAggressive2K[`${fund.bseSchemeCode.toLowerCase()}`]
                          : basketName.includes('cm')
                            ? cm[`${fund.bseSchemeCode.toLowerCase()}`]
                            : basketName == '6+_retirement_without_us_tech'
                              ? sixPlusWithoutUsTechSIP[`${fund.bseSchemeCode.toLowerCase()}`]
                              : basketName == '3-6_education_without_us_tech'
                                ? threeToSixWithoutUsTechSIP[`${fund.bseSchemeCode.toLowerCase()}`]
                                : basketName == '3-6 education'
                                  ? educationConstituentsSIPWeightage[`${fund.bseSchemeCode.toLowerCase()}`]
                                  : basketName.includes('wedding')
                                    ? weddingConstituentsWeightageSIP[`${fund.bseSchemeCode.toLowerCase()}`]
                                    : basketName.includes('1-3')
                                      ? oneToThreeYrConstituentsWeightage[`${fund.bseSchemeCode.toLowerCase()}`]
                                      : basketName.includes('emergency')
                                        ? emergencyConstituentsSIPWeightage[`${fund.bseSchemeCode.toLowerCase()}`]
                                        : basketName.includes('liquid')
                                          ? liquidSIP[`${fund.bseSchemeCode.toLowerCase()}`]
                                          : basketName.includes('arbitrage')
                                            ? arbitrageSIP[`${fund.bseSchemeCode.toLowerCase()}`]
                                            : basketName.includes('commodities')
                                              ? commoditiesConstituentsSIPWeightage[`${fund.bseSchemeCode.toLowerCase()}`]
                                              : basketName.includes('1')
                                                ? oneYrConstituentsWeightage[`${fund.bseSchemeCode.toLowerCase()}`]
                                                : basketName.includes('us_tech')
                                                  ? usTech[`${fund.bseSchemeCode.toLowerCase()}`]
                                                  : basketName.includes('china_equity')
                                                    ? chinaEquity[`${fund.bseSchemeCode.toLowerCase()}`]
                                                    : anytimeConstituentsWeightage[`${fund.bseSchemeCode.toLowerCase()}`],
        }))
      : []

  // const minimumInvestmentAmount = filteredConstituents
  //   ? filteredConstituents.reduce((acc, fund) => acc + (Number(fund.minSip) || 0), 0)
  //   : 0

  const handleSubmit = async () => {
    setError('')

    // Basic validation
    if (!amount || isNaN(Number(amount)) || Number(amount) <= 0) {
      setError('Please enter a valid investment amount')
      return
    }

    if (
      location?.state?.payload?.orderInvestmentAmount &&
      location?.state?.payload?.orderInvestmentBreakdown
    ) {
      const url = `${env.API_URL}adminservice/api/actionPlan/subsequentOneTimeOrder`

      const payload = location?.state?.payload

      setIsLoading(true)

      const response = await post(url, payload)

      setIsLoading(false)

      if (
        response?.status === 'SUCCESS' &&
        response?.message?.includes('Order created successfully')
      ) {
        onOpen('openAdminPopup', {
          title: 'Order Created!',
          message: 'Your order has been successfully created.',
          severity: 'success',
        })
      } else {
        onOpen('openAdminPopup', {
          title: 'Order Failed!',
          message:
            'There was an issue creating your order. Please try again later or contact support if the issue persists.',
          severity: 'error',
        })
      }

      return
    }

    const basket = location?.state?.basket || []
    console.log('🚀 ~ handleSubmit ~ basket:', basket)
    // const universalBasketId = location?.state?.basket[0]?.universalBasketId
    // const totalInvestment = basket.reduce((sum, item) => sum + item.netInvestedAmount, 0)

    const newData = filteredConstituents?.map((item) => {
      const investmentAmount = parseFloat((amount / 100) * item.weightage)

      return {
        ...item,
        investmentAmount,
        customerBasketInvestmentId:
          location?.state?.basket[0]?.customerBasketInvestmentId ||
          location?.state?.basket?.customerBasketInvestmentId,
        customerBasketName:
          location?.state?.basket[0]?.customerBasketName ||
          location?.state?.basket?.customerBasketName,
      }
    })

    const url = `${env.API_URL}adminservice/api/actionPlan/subsequentOneTimeOrder`

    const payload = {
      clientCode: location?.state?.clientCode,
      sipOrderInvestmentAmount: amount,
      sipOrderInvestmentBreakdown: newData?.filter((fund) => fund?.weightage > 0),
      customerBasketInvestmentId:
        location?.state?.basket[0]?.customerBasketInvestmentId ||
        location?.state?.basket?.customerBasketInvestmentId,
    }

    setIsLoading(true)

    const response = await post(url, payload)

    setIsLoading(false)

    if (
      response?.status === 'SUCCESS' &&
      response?.message?.includes('Order created successfully')
    ) {
      onOpen('openAdminPopup', {
        title: 'Order Created!',
        message: 'Your order has been successfully created.',
        severity: 'success',
      })
    } else {
      onOpen('openAdminPopup', {
        title: 'Order Failed!',
        message:
          'There was an issue creating your order. Please try again later or contact support if the issue persists.',
        severity: 'error',
      })
    }
  }

  return (
    <>
      <ChevronLeft onClick={() => navigate(-1)} className='cursor-pointer' />
      <div className='container flex items-center justify-center min-h-[70vh] py-12'>
        <Card className='w-full max-w-xl'>
          <CardHeader>
            <CardTitle className='text-2xl font-bold'>
              {location?.state?.basket[0]?.customerBasketName ||
                location?.state?.basket?.customerBasketName}{' '}
              - (SIP)
            </CardTitle>
            <CardDescription>
              Enter the amount you would like to invest in your portfolio
            </CardDescription>
          </CardHeader>

          <CardContent>
            <div className='space-y-4'>
              <div className='space-y-2'>
                <Label htmlFor='amount' className='font-semibold'>
                  SIP Investment Amount
                </Label>
                <div className='relative'>
                  <Input
                    startAdornment='₹'
                    id='amount'
                    type='text'
                    placeholder='0'
                    className='pl-10'
                    value={amountInput}
                    onChange={handleAmountInputChange}
                  />
                </div>
                {error && <p className='text-sm font-medium text-red-500'>{error}</p>}
              </div>

              <div className='flex justify-center items-center'>
                <Button
                  variant='link'
                  size='simple'
                  className='text-primary-500 p-0 border-b border-dashed border-primary-500 rounded-none hover:no-underline'
                  disabled={amount <= 0}
                  onClick={(e) => {
                    e.stopPropagation(),
                      onOpen('OpenAdminMFBreakdown', {
                        constituents: filteredConstituents,
                        amount: amount,
                      })
                  }}
                >
                  View detailed breakdown
                  <ChevronDown className='h-4 w-4 ml-1' />
                </Button>
              </div>

              {/* {amount < minimumInvestmentAmount && (
                <div>
                  <p className='text-sm text-error-500 text-center'>
                    Minimum investment amount is {toCurrency(minimumInvestmentAmount)}
                  </p>
                </div>
              )} */}

              {/* <div className='my-12 max-w-3xl'>
                <Label className='text-sm text-black-300'>
                  Select SIP Date{' '}
                  <span className='text-black-400'>
                    (Next Instalment - {addNumberSuffix(+nextSipDay)} {monthNames[nextSipMonth - 1]}{' '}
                    {nextSipYear})
                  </span>
                </Label>
                <Popover>
                  <PopoverTrigger asChild>
                    <Button
                      variant={'outline'}
                      className='pl-3 font-normal border-none bg-primary-50 rounded-lg w-full flex justify-between max-w-3xl mx-auto'
                    >
                      <span className='text-primary-500 flex items-center gap-x-2'>
                        <CalendarIcon className='ml-auto h-4 w-4 opacity-50' />
                        {addNumberSuffix(+selectedDay)} of every month
                      </span>

                      <Pen className='h-4 w-4 text-primary-500' />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className='p-0 w-auto rounded-full' align='center' side='top'>
                    <div className='flex gap-x-2 p-2'>
                      {sipDates.map((day, index) => (
                        <Button
                          key={(day + index).toString()}
                          className={`h-8 w-8 rounded-full inline-block ${
                            selectedDay !== +day
                              ? 'bg-white border border-primary-50 text-black-400 hover:bg-primary-50'
                              : 'text-white'
                          }`}
                          size='simple'
                          onClick={() => setSelectedDay(+day)}
                        >
                          {day}
                        </Button>
                      ))}
                    </div>
                  </PopoverContent>
                </Popover>
              </div> */}
            </div>
          </CardContent>

          <CardFooter>
            <Button
              onClick={handleSubmit}
              type='submit'
              className='w-full disabled:bg-primary-300'
              disabled={isLoading || amount <= 0}
            >
              {isLoading ? 'Processing...' : 'Continue'}
            </Button>
          </CardFooter>
        </Card>
      </div>
    </>
  )
}

export default InvestMoreSIP
